__turbopack_context__.v({
  "arrowCollapsed": "SingleTeamFocusArea-module-scss-module__61vScq__arrowCollapsed",
  "arrowExpanded": "SingleTeamFocusArea-module-scss-module__61vScq__arrowExpanded",
  "childTag": "SingleTeamFocusArea-module-scss-module__61vScq__childTag",
  "children": "SingleTeamFocusArea-module-scss-module__61vScq__children",
  "parentTag": "SingleTeamFocusArea-module-scss-module__61vScq__parentTag",
  "root": "SingleTeamFocusArea-module-scss-module__61vScq__root",
  "rootExpanded": "SingleTeamFocusArea-module-scss-module__61vScq__rootExpanded",
});
